export var apiPath="/v1/certificates";var actionType="ASSETS";export default actionType;